export function getApiBaseUrlFromEnv(): string {
  return import.meta.env.VITE_API_BASE_URL ?? "http://localhost:4000";
}

export function getAssetsCdnUrlFromEnv(): string | undefined {
  return import.meta.env.VITE_ASSETS_CDN_URL;
}

export function getWebBaseUrlFromEnv(): string {
  return import.meta.env.VITE_WEB_BASE_URL ?? "https://muminsmart.com";
}
